import '@/common';
import { createActionWidget } from '@/widgets/ActionWidget';
import { feedbackWidget} from '@/common/widgets';
import { ModalData } from '@/widgets/FeedbackWidget/types';
import {JSONParser} from "@/utils/JSONParser";

createActionWidget(document.querySelector('#action-widget')!);

[...document.querySelectorAll('.js-feedback-widget')].forEach((el) => {
    el.addEventListener('click', () => {
        const parser = new JSONParser('js-feedback-widget-parser');
        const action = el.getAttribute('data-action');
        const rawModalData = parser.parse<ModalData>(el.getAttribute('data-modal'));

        switch (action) {
            default:

                const trailer = Object.assign({}, rawModalData.trailer, {});

                const modalData = Object.assign({}, rawModalData, {
                    trailer,
                });

                feedbackWidget.show(modalData);
                break;
        }
    });
});
